import gameIds from '../../hub/data/GameIds';

export const GAME_ID = gameIds.WORD_CITY;

export const SCREENS = {
  PROGRESS: 'WORD_CITY_PROGRESS',
  STANDARD: 'WORD_CITY_STANDARD',
  LOADING: 'WORD_CITY_LOADING',
  FEEDBACK: 'WORD_CITY_FEEDBACK',
  ONBOARDING: 'WORD_CITY_ONBOARDING',
};

export const REDUX_ACTIONS = {
  // game details actions
  UPDATE_GAME_PRACTICE_DETAILS: 'WORD_CITY_UPDATE_GAME_PRACTICE_DETAILS',
  UPDATE_GAME_ONBOARDING_DETAILS: 'WORD_CITY_UPDATE_GAME_ONBOARDING_DETAILS',
  RESET_GAME_TOPPERS_DETAILS_FOR_QUEST: 'WORD_CITY_RESET_GAME_TOPPERS_DETAILS_FOR_QUEST',
  // screen actions
  CHANGE_SCREEN: 'WORD_CITY_CHANGE_SCREEN',
  // curriculum actions
  LOAD_CURRICULUM: 'WORD_CITY_LOAD_CURRICULUM',
  SELECT_LEVEL: 'WORD_CITY_SELECT_LEVEL',
  // standard round actions
  INIT_STANDARD_ROUND: 'WORD_CITY_INIT_STANDARD_ROUND',
  NEXT_STANDARD_STEP: 'WORD_CITY_NEXT_STANDARD_STEP',
  DISCONTINUE_STANDARD_ROUND: 'WORD_CITY_DISCONTINUE_STANDARD_ROUND',
  BUILD_STANDARD_TOWER: 'WORD_CITY_BUILD_STANDARD_TOWER',
  MARK_PROGRESS: 'WORD_CITY_MARK_PROGRESS',
  QUICK_ROUND: 'WORD_CITY_QUICK_ROUND',
  // standard step actions
  INIT_STANDARD_STEP: 'WORD_CITY_INIT_STANDARD_STEP',
  SERVE_ADDER_ANSWER: 'WORD_CITY_SERVE_ADDER_ANSWER',
  SERVE_CHANGER_ANSWER: 'WORD_CITY_SERVE_CHANGER_ANSWER',
  SERVE_REMOVER_ANSWER: 'WORD_CITY_SERVE_REMOVER_ANSWER',
  COMPLETE_STEP: 'WORD_CITY_COMPLETE_STEP',
  LOSE_TOPPER_REWARD: 'WORD_CITY_LOSE_TOPPER_REWARD',
  // narration actions
  INIT_STANDARD_TIP_NARRATION: 'WORD_CITY_INIT_STANDARD_TIP_NARRATION',
  CLEAR_NARRATION: 'WORD_CITY_CLEAR_NARRATION',
  INIT_STANDARD_HINT_NARRATION: 'WORD_CITY_INIT_STANDARD_HINT_NARRATION',
  // game mode actions
  TURN_REWARD_MODE_ON: 'WORD_CITY_TURN_REWARD_MODE_ON',
  TURN_REWARD_MODE_OFF: 'WORD_CITY_TURN_REWARD_MODE_OFF',
  SWITCH_JIGGLE_WRECKING_BALL_MODE: 'WORD_CITY_SWITCH_JIGGLE_WRECKING_BALL_MODE',
  TURN_ONBOARDING_MODE_ON: 'WORD_CITY_TURN_ONBOARDING_MODE_ON',
  TURN_STANDARD_MODE_ON: 'WORD_CITY_TURN_STANDARD_MODE_ON',
  // onboarding round actions
  INIT_ONBOARDING_ROUND: 'WORD_CITY_INIT_ONBOARDING_ROUND',
  NEXT_ONBOARDING_STEP: 'WORD_CITY_NEXT_ONBOARDINGSTEP',
  BUILD_ONBOARDING_TOWER: 'WORD_CITY_BUILD_ONBOARDING_TOWER',
  // feedback actions
  INIT_FEEDBACK_ROUND: 'WORD_CITY_INIT_FEEDBACK_ROUND',
  SELECT_TOPPER: 'WORD_CITY_SELECT_TOPPER',
  UNLOCK_TOPPER: 'WORD_CITY_UNLOCK_TOPPER',

  // debug tools
  AUTO_COMPLETE_CORRECTLY: 'AUTO_COMPLETE_CORRECTLY',
  AUTO_COMPLETE_INCORRECTLY: 'AUTO_COMPLETE_INCORRECTLY',
};

export const DROPZONE_KEYS = {
  DROPZONE_LEFT: 'DROPZONE_LEFT',
  DROPZONE_RIGHT: 'DROPZONE_RIGHT',
};

export const INTERACTION_TYPES = {
  CHANGER: 'changer',
  ADDER: 'adder',
  REMOVER: 'remover',
};

/* Standard screen geometry. standardContainer's 464px (576 screen - 112 header) splits into the
314px top container and the letters tray; the top container splits evenly between question row and
tower. */
export const STANDARD_TOP_ROW_HEIGHT = 157;
export const STANDARD_TRAY_HEIGHT = 150;

// towerWordBox is 110 tall with a 2px margin top and bottom (styles/standard.js)
export const TOWER_FLOOR_HEIGHT = 114;

/* A rise starts one floor above where the stack was resting, so its start state is the previous
floor arrangement and nothing jumps. The ground floor is the exception: it rests centred in its band
(standardTopSecondRowContainer) rather than on the line towerContainer stacks from, so the opening
rise starts half a band's slack lower. The band is the even split's other half, so it is the same 157
tall as the question row above it. */
export const FIRST_FLOOR_RISE_OFFSET =
  TOWER_FLOOR_HEIGHT - ((STANDARD_TOP_ROW_HEIGHT - TOWER_FLOOR_HEIGHT) / 2);

/* Half the band's slack, which is exactly how much lower the centred ground floor sits than the line
the stack climbs from. Lowering the question row by the same amount on that one step puts the pair
back in the middle of the play area: 21.5px of air above and below instead of all of it below. */
export const FIRST_STEP_QUESTION_ROW_OFFSET = (STANDARD_TOP_ROW_HEIGHT - TOWER_FLOOR_HEIGHT) / 2;

// a tile's slot in the question row and the full-size letters bank (styles/standard.js tileContainer)
export const TILE_SLOT_SIZE = 110;
export const TILE_SLOT_MARGIN = 15;

/* Dropping a letter re-centres the question row by half a slot, so every surviving letter travels
the same distance — those left of the gap rightwards, those right of it leftwards. */
export const TILE_GAP_CLOSE_SHIFT = (TILE_SLOT_SIZE + (TILE_SLOT_MARGIN * 2)) / 2;

// the sky is 1902 tall and shows 426px at the start, leaving this much to scroll over the round
export const STANDARD_BACKGROUND_ITERATIVE_HEIGHT = 1476;

/* How far the sky slides per floor gained. Short of TOWER_FLOOR_HEIGHT, so the distant sky lags the
tower it sits behind, and no more than the longest round can spend of the 1476 the sky has to give.
The tower carries the reference word as its ground floor, so a 24-item round ends at 25 floors and
getBackgroundOffset spends 24 rises, not 23: 24 x 61 = 1464 fits, where 64 would clamp the last step
of a full round to 4px and the sky would visibly stall. Tying it to floors rather than to a fraction
of the round keeps a step feeling the same everywhere, onboarding's three steps included. */
export const STANDARD_BACKGROUND_FLOOR_RISE = 61;

// the star's box, not its ink — its path fills about three quarters of its 60x60 viewBox
export const ROUND_COMPLETE_MARK_SIZE = 140;

/* Standard screen timing. A completed step raises the camera: sky and tower are kicked off by the
same task in getCorrectAnswerSequence, so they share a duration. */
export const STEP_RISE_DURATION_MS = 600;

export const STEP_ROW_FADE_OUT_MS = 0;
export const STEP_ROW_FADE_IN_MS = 250;

/* The wrecking ball's blast shrinks the struck tile away, and only then does the row close the gap.
The answer itself waits for both, so the correct-answer sequence never starts over a moving row. */
export const REMOVER_BLAST_DURATION_MS = 350;
export const REMOVER_GAP_CLOSE_DURATION_MS = 300;

export const LOCKED_BOX_SLIDE_DELAY_MS = 900;
export const LOCKED_BOX_SLIDE_DURATION_MS = 300;

// waits out the longest entrance chain, so Alex never talks over something moving
export const TIP_NARRATION_DELAY_MS = LOCKED_BOX_SLIDE_DELAY_MS + LOCKED_BOX_SLIDE_DURATION_MS;

// once the reveal's starburst is opaque it hides the stage, which is when the crane can be cleared
export const REWARD_REVEAL_COVER_DELAY_MS = 1000;
export const REWARD_REVEAL_COVER_FADE_MS = 260;
export const REWARD_REVEAL_COVERED_AT_MS = REWARD_REVEAL_COVER_DELAY_MS + REWARD_REVEAL_COVER_FADE_MS;

export const BANK_CONTENT_LIFT = 4;

/* Bank tiles are dealt in from below the stage. The distance only has to clear the tray, since
globalStyles.container crops anything past the bottom edge. */
export const BANK_DEAL_DISTANCE = 200;
export const BANK_DEAL_DURATION_MS = 320;
export const BANK_DEAL_STAGGER_MS = 70;

/* The rejected dropzone holds its inverted colours this long, then fades back to normal. The pair
still totals the same 950ms it always did; the fade just gives its time back to the hold, so the red
snaps off rather than dissolving. The poke runs inside the hold. */
export const DROPZONE_REJECT_HOLD_MS = 850;
export const DROPZONE_REJECT_FADE_MS = 100;
export const DROPZONE_REJECT_POKE_MS = 200;

export const ROUND_COMPLETE_MARK_POP_MS = 700;
export const ROUND_COMPLETE_FADE_MS = 400;

// floor under the star's own animationend, so a stalled animation can't strand a finished round
export const ROUND_COMPLETE_MARK_TIMEOUT_MS = 4000;

export const NARRATION_TYPES = {
  STANDARD_TIP: 'STANDARD_TIP',
  STANDARD_HINT: 'STANDARD_HINT',
};

export const NARRATION_TIP_TYPES = {
  ONBOARDING_TIP_DRAG_THE_LETTER: 1,
  STANDARD_TIP_CHANGE: 2,
  ONBOARDING_TIP_REMOVE: 3,
};

export const NARRATION_HINT_TYPES = {
  LOOK_BEGINNING: 'lookBeginning',
  LOOK_MIDDLE: 'lookMiddle',
  LOOK_ENDING: 'lookEnding',
  LOOK_MIDDLES: 'lookMiddles',
  LOOK_ENDINGS: 'lookEndings',
  CHANGE_SOUND: 'changeSound',
  CHANGE_SOUND_TO: 'changeSoundTo',
  CHANGE_BEGINNING: 'changeBeginning',
  CHANGE_MIDDLE: 'changeMiddle',
  CHANGE_MIDDLES: 'changeMiddles',
  CHANGE_ENDING: 'changeEnding',
  CHANGE_ENDINGS: 'changeEndings',
  REMOVE_BEGINNING: 'removeBeginning',
  REMOVE_ENDING: 'removeEnding',
  REMOVE_SOUND: 'removeSound',
  ADD_SOUND: 'addSound',
  ADD_BEGINNING: 'addBeginning',
  ADD_ENDING: 'addEnding',
  ADD_MAGIC: 'addMagic',
  SOUND_BEGINNING: 'soundBeginning',
};

export const MOVES_AMOUNT_STANDARD_HINT_ON = 2;

export const LETTERS_BANK_LENGTH_SMALL_TILE_MODE_ON = 7;

export const TOPPERS = {
  DEFAULT: 0,
  BIRD: 1,
  CAKE: 2,
  GARAGE: 3,
  GORILLA: 4,
  HELICOPTER: 5,
  MOUNTAIN: 6,
};

export const TOPPER_TYPES = {
  CITY: 'CITY',
  BOX: 'BOX',
  TOWER: 'TOWER',
  REWARD: 'REWARD',
};

export const TOPPER_SIZES = {
  [`${TOPPER_TYPES.CITY}`]: 125,
  [`${TOPPER_TYPES.BOX}`]: 250,
  [`${TOPPER_TYPES.TOWER}`]: 250,
  [`${TOPPER_TYPES.REWARD}`]: 350,
};

export const COLORS_MAP = {
  RED: '#ea5348',
  ORANGE: '#eb7200',
  GREEN: '#5d9e0e',
  BLUE: '#007cd7',
  TEAL: '#1fa490',
  PURPLE: '#9c61d0',
  PINK: '#dd6aab',
};

/* The raised teal pill shared by Continue, Done and Select: the face plus
the same hue shaded down, which is the pair that reads as raised rather than flat. */
export const BUTTON_FACE_COLOR = COLORS_MAP.TEAL;
export const BUTTON_EDGE_COLOR = '#167365';

export const COLOR_NAMES_INDEXED = [
  'RED',
  'ORANGE',
  'GREEN',
  'BLUE',
  'TEAL',
  'PURPLE',
  'PINK',
];

export const COLORS_INDEXED = [
  '#ea5348',
  '#eb7200',
  '#5d9e0e',
  '#007cd7',
  '#1fa490',
  '#9c61d0',
  '#dd6aab',
];

export const COLORS_COUNT = COLORS_INDEXED.length;

export const FEEDBACK_SCENES = {
  TOWER: 'TOWER',
  TOPPER_SELECTION: 'TOPPER_SELECTION',
  TOPPER_TOWER: 'TOPPER_TOWER',
  CITY: 'CITY',
};

export const TOWERS_PER_CITY_DISTRICT = 6;

/* City tower scale by floor count, as [maxFloors, scale, offsetY] ascending. Grounded towers are
content-height, so without the scale anything past the first tier runs off the top of the 464px scene.
offsetY nudges the tower down by that many px to leave headroom above the topper, more of it for the
tiers that render tall. */
export const CITY_TOWER_SCALE_TIERS = [
  [7, 1, 10],
  [13, 0.7, 10],
  [17, 0.55, 10],
  [19, 0.47, 10],
  [22, 0.44, 17],
  [Infinity, 0.38, 17],
];

/* The toppers on offer arrive one at a time, each with its own pop. Locked slots take no turn, so
the row only counts the ones a child can actually pick. */
// long enough for the full turn it arrives on to read, without holding the row up
export const TOPPER_POP_MS = 760;
export const TOPPER_POP_STAGGER_MS = 140;
// the Select button waits out its topper's pop, then eases in on its own
export const TOPPER_SELECT_FADE_MS = 500;
// a locked slot has nothing to pop, so it eases in instead of arriving already on screen
export const TOPPER_LOCK_FADE_MS = 400;

/* Onboarding's topper lives in the same map as the levels', so the city can crown its tower long
after the round. A string key rather than a number, so it can never be mistaken for a level id. */
export const ONBOARDING_TOPPER_KEY = 'onboarding';

/* Onboarding hands out no toppers, so its row is the flag alone. A standard round sizes its own row
from the level's topper questions — see initStandardRound. */
export const TOPPERS_LIST_LENGTH = {
  ONBOARDING: 1,
};

export const QUESTION_TYPES = {
  ONBOARDING: 'ONBOARDING',
  STANDARD: 'STANDARD',
};

export const WRECKING_BALL_TILE_INDEX = -1;

export const MALE_VOICE_NARRATION_SECTIONS = ['words', 'phonemes'];
